import PropTypes from 'prop-types'
import { Input } from 'baseui/input'
import { Select } from 'baseui/select'
import { Button } from 'baseui/button'

import useDevTools from '@/containers/DevToolsNew/shared/useDevTools'
import CountrySelectLabel from './CountrySelectLabel'
import useContactsFiltersBar from './useContactsFiltersBar'

import {
  FiltersRow,
  SearchInputWrap,
  CountrySelectWrap,
  SearchButtonWrap,
  OnlyWithContractsWrap,
  ToggleButtonOverrides,
  ContactsSearchInputOverrides,
  ContactsCountrySelectOverrides,
  ContactsSearchButtonOverrides,
} from './styled-components'

const ContactsFiltersBar = ({ filters, countrySelect }) => {
  const { t } = useDevTools()

  const {
    query,
    onlyWithContracts,
    isLoading,
    onQueryChange,
    onOnlyWithContractsChange,
    onSearch,
  } = filters

  const { options, value, onChange } = countrySelect

  const { canSearch, handleKeyDown, searchButtonEnhancer, toggleEnhancer } =
    useContactsFiltersBar({
      query,
      onlyWithContracts,
      isLoading,
      onSearch,
    })

  return (
    <FiltersRow>
      <SearchInputWrap>
        <Input
          value={query}
          onChange={event => onQueryChange(event.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={t('contacts.placeholder')}
          clearable
          size="compact"
          overrides={ContactsSearchInputOverrides}
        />
      </SearchInputWrap>

      <CountrySelectWrap>
        <Select
          options={options}
          value={value}
          onChange={({ value: nextValue }) => onChange(nextValue)}
          searchable={false}
          clearable={false}
          valueKey="id"
          labelKey="label"
          size="compact"
          overrides={ContactsCountrySelectOverrides}
          getOptionLabel={({ option }) => (
            <CountrySelectLabel
              FlagIcon={option?.FlagIcon}
              label={option?.label}
              size={18}
            />
          )}
          getValueLabel={({ option }) => (
            <CountrySelectLabel
              FlagIcon={option?.FlagIcon}
              label={option?.label}
              size={18}
            />
          )}
        />
      </CountrySelectWrap>

      <OnlyWithContractsWrap>
        <Button
          type="button"
          size="compact"
          kind={onlyWithContracts ? 'primary' : 'secondary'}
          onClick={() => onOnlyWithContractsChange(!onlyWithContracts)}
          startEnhancer={toggleEnhancer}
          overrides={ToggleButtonOverrides}
        >
          {t('contacts.only_with_contracts')}
        </Button>
      </OnlyWithContractsWrap>

      <SearchButtonWrap>
        <Button
          startEnhancer={searchButtonEnhancer}
          onClick={onSearch}
          isLoading={isLoading}
          disabled={!canSearch}
          size="compact"
          overrides={ContactsSearchButtonOverrides}
        >
          {t('contacts.search_button')}
        </Button>
      </SearchButtonWrap>
    </FiltersRow>
  )
}

ContactsFiltersBar.propTypes = {
  filters: PropTypes.shape({
    query: PropTypes.string.isRequired,
    onlyWithContracts: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool,
    onQueryChange: PropTypes.func.isRequired,
    onOnlyWithContractsChange: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
  }).isRequired,

  countrySelect: PropTypes.shape({
    options: PropTypes.array.isRequired,
    value: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
}

export default ContactsFiltersBar
